export const SUB_LOCAL_PLACE = 'SUB_LOCAL_PLACE';
export const AIRPORT_AND_STATION = 'AIRPORT_AND_STATION';
export const AIRPORT = 'AIRPORT';
export const TRAIN_STATION = 'TRAIN_STATION';
export const POI = 'POI';
export const HOT_SPRING = 'HOT_SPRING';
export const SUBDIVISION = 'SUBDIVISION';
export const TITLE = 'Title';
export const DESCRIPTION = 'Description';
export const H1 = 'H1';
export const PAGE_INDICATOR = '_page';

export const labelTypes = {
  SUB_LOCAL_PLACE: 'SubLocal',
  AIRPORT_AND_STATION: 'Airport-Station',
  POINT_OF_INTEREST: 'POI',
  HOT_SPRING: 'Onsen',
  SUBDIVISION: 'Subdivision',
  LOCAL_PLACE: 'Local',
};

export const seoLabelTypes = {
  SUB_LOCAL_PLACE: 'SubLocal',
  LOCAL_PLACE: 'Local',
  AIRPORT_AND_STATION: 'Airport-Station',
  POINT_OF_INTEREST: 'POI',
  HOT_SPRING: 'HotSprings',
  SUBDIVISION: 'Subdivision',
  AIRPORT: 'Airport',
  TRAIN_STATION: 'Station',
};
